let ja = {
    "translation" : {
        "thanks_registration": "入力されたメールアドレス宛てに、確認メールを送信しました。メールに記載されている確認コードを入力し、登録を完了させてください。",
        "done_registration": "あなたのメールアドレスの確認が成功し、登録が完了しました！",
    }
};

export default ja;